import { TFunction } from 'i18next';
import { routes } from '@lon/shared/configs';
import { SidebarLink } from './types';

export const getFirstSections = (t: TFunction): SidebarLink[] => {
  return [
    {
      id: '1',
      title: t('classes.classesLink'),
      path: routes.classes.root,
      icon: 'user-group',
      end: true,
      pathsToHighlight: [
        '/classes',
        '/classes/create',
        '/classes/settings',
        {
          path: '/classes/:classId',
          regExp: /^\/classes\/\w{8}-\w{4}-\w{4}-\w{4}-\w{12}\/?$/,
        },
        '/classes/:classId/settings',
        '/classes/:classId/gradebook',
        '/classes/:classId/roster',
        '/classes/:classId/roster/students-page',
        '/classes/:classId/roster/manage-subgroups',
        '/classes/:classId/roster/manage-subgroups/:subgroupId',
        '/classes/:classId/roster/manage-subgroups/:subgroupId',
      ],
    },
    {
      id: '2',
      title: t('classes.assignmentsLink'),
      path: routes.classes.assignments.root,
      icon: 'subscription-outlined',
      pathsToHighlight: [
        '/classes/:classId/assignment/:assignmentId',
        '/classes/:classId/student-assignments/:studentId',
        '/classes/district-assessments/:studentId/:sessionId',
        '/classes/student-assignments/:studentId',
        '/classes/assignments',
        '/classes/assignments/:assignmentId',
        '/classes/assignments/assignment-list/:listId',
      ],
    },
    {
      id: '3',
      title: t('classes.studentsLink'),
      path: routes.classes.students,
      icon: 'school-outlined',

      pathsToHighlight: [
        '/classes/students',
        '/classes/create-student',
        '/classes/edit-student/:studentId',
      ],
    },
  ];
};

export const getSecondSections = (
  t: TFunction
): {
  title: string;
  path?: string;
  icon: string;
  subItems: { title: string; path: string }[];
}[] => {
  return [
    {
      title: t('classes.reportsLink'),
      icon: 'report',
      subItems: [
        {
          title: t('classes.reportsStandards'),
          path: routes.classes.reportDashboard.standard,
        },
        {
          title: t('classes.reportsDA'),
          path: routes.classes.reportDashboard.districtAssessments,
        },
      ],
    },
  ];
};
